// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"55692523","745":"c27f9fd4"}[chunkId] + ".chunk.js";
};